import { useAppSelector, useAppTranslation } from 'app/hooks';
import CloseIcon from 'assets/icons/CloseIcon';
import Typo from 'consts/typography';
import { selectBets, selectFutureBets } from 'features/home/homeSlice';
import useThemes from 'hooks/useThemes';
import React, { useState } from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { FaCubes } from 'react-icons/fa';
import BetFormMainTab from './BetFormMainTab';
import BetSlipForm from './BetSlipForm';
import MyBetsForm from './MyBetsForm';

interface BetFormButtonProps {}
export const BetFormButton: React.FC<BetFormButtonProps> = () => {
  const [currentTab, setCurrentTab] = React.useState<number>(1);
  const [showBetForm, setShowBetForm] = useState<boolean>(false);
  const bets = useAppSelector(selectBets);
  const futureBets = useAppSelector(selectFutureBets);

  const onShowChat = () => {
    setShowBetForm((prev) => !prev);
    setCurrentTab(1);
  };
  const changeTab = (tab: number): void => {
    setCurrentTab(tab);
  };
  return (
    <div className="bet-form-btn__btn-container">
      <button className="bet-form-btn__show-btn" onClick={onShowChat}>
        {showBetForm ? (
          <CloseIcon isDarkMode={false} width="20" height="20" />
        ) : (
          <FaCubes width={40} height={40} />
        )}
      </button>
      {bets.length + futureBets.length !== 0 && !showBetForm && (
        <p className="amount-bet">{bets.length + futureBets.length}</p>
      )}
      {showBetForm && (
        <div className="bet-container slide-in">
          <div className="bet-form">
            <BetFormMainTab currentTab={currentTab} changeTab={changeTab} />
            {currentTab === 1 && <BetSlipForm />}
            {currentTab === 2 && <MyBetsForm />}
          </div>
        </div>
      )}
    </div>
  );
};

export default BetFormButton;
